import React, { useState } from 'react'
import { CollapsibleListToggle } from '../../../legacy-design-system/list'
import { css, cx } from '@emotion/css'
import { ruleSeveritiesi18nConfig, VulnerabilityPolicy } from '../index'
import { FormattedMessage } from 'react-intl'
import { paragraphTextCss } from '../../../legacy-design-system/text'
import { RuleSeverity } from '../../shared'

export function VulnerabilityRulesCell({
  rowData: { allRules, rules = [], ruleSeverities = [] },
  listDataTestID
}: {
  readonly rowData: VulnerabilityPolicy
  readonly listDataTestID?: string
}) {
  const [isExpanded, setIsExpanded] = useState(false)
  const listStyle = cx(
    paragraphTextCss,
    css`
      list-style: none;
      padding: 0;
      margin: 0;
    `
  )

  if (allRules) {
    return (
      <div>
        <ul className={listStyle} data-testid={listDataTestID}>
          <li>
            <FormattedMessage id="title_remediationPolicy_allRules">
              {(msg) => <span>{msg} </span>}
            </FormattedMessage>
          </li>
        </ul>
      </div>
    )
  }

  const rulesAndSeverities: Array<{
    readonly label: string | RuleSeverity
    readonly isI18n?: boolean
  }> = [
    ...ruleSeverities.map((severity) => ({
      label: severity,
      isI18n: true
    })),
    ...rules.map((rule) => ({
      label: rule.title,
      isI18n: false
    }))
  ]

  const visible = isExpanded
    ? rulesAndSeverities
    : rulesAndSeverities.slice(0, 5)

  return (
    <div>
      <ul className={listStyle} data-testid={listDataTestID}>
        {visible.map((ruleOrSeverity, ruleOrSeverityIndex) => (
          <li key={ruleOrSeverityIndex}>
            {ruleOrSeverity.isI18n ? (
              <FormattedMessage
                id={ruleSeveritiesi18nConfig[ruleOrSeverity.label]}
              >
                {(msg) => <span>{msg} </span>}
              </FormattedMessage>
            ) : (
              ruleOrSeverity.label
            )}
          </li>
        ))}
      </ul>
      {rulesAndSeverities.length > 5 && (
        <CollapsibleListToggle
          isExpanded={isExpanded}
          onToggle={(_isExpanded) => {
            if (isExpanded !== _isExpanded) {
              setIsExpanded(_isExpanded)
            }
          }}
        />
      )}
    </div>
  )
}
